import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { EmailValidateActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';

@Injectable()
export class EmailValidateEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService
  ) {}

  private common = new Common();

  getEmailValidate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmailValidateActions.getEmailValidate),
      switchMap((action) =>
        this.onboardingProductsService.getEmailValidate(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
          EmailValidateActions.getEmailValidateSucess({ response: res })
          ),
          catchError((error) =>
            of(
              EmailValidateActions.getEmailValidateError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );

}
